import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useQuery } from "@apollo/client";
import { GET_WATER_SYSTEM_MENU } from "../../queries/publicQrys/SystemHeaderViewQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import { siteMapData } from "../../siteMapData";
import ErrorMessage from "./ErrorHandler";

const WaterSystemSearch = ({ handleSearch, autoFocus }) => {
  const { user } = useContext(UserContext);
  const [searchMenu, setSearchMenu] = useState([]);
  let siteMapSearch = [];
  const { loading, error } = useQuery(GET_WATER_SYSTEM_MENU, {
    onCompleted: (d) => {
      if (user.isPublic) {
        siteMapSearch = siteMapData.filter(
          (siteObj) => siteObj.accessType === "public" || siteObj.accessType === "public-external"
        );
        setSearchMenu(d.getWaterSystemMenu.concat(siteMapSearch));
      } else if (user.isPortalUser) {
        user.assignments.forEach((element) => {
          siteMapSearch = siteMapData.filter(
            (siteObj) =>
              siteObj.accessType === "public" ||
              siteObj.accessType === "public-external" ||
              siteObj.roles.includes("portal") ||
              siteObj.moduleCode.includes(element.moduleCode)
          );
        });
        setSearchMenu(d.getWaterSystemMenu.concat(siteMapSearch));
      } else {
        //user is staff and/or admin
        setSearchMenu(d.getWaterSystemMenu.concat(siteMapData));
      }
    }
  });

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorMessage error={error} />;
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid grey",
      // This line disable the blue border
      boxShadow: "none"
    })
  };
  return (
    <>
      <Row>
        <Col>
          <Select
            options={searchMenu}
            isSearchable
            className='mb-4'
            placeholder='Search by County/Water System/PWS ID/Report'
            onChange={handleSearch}
            autoFocus={autoFocus}
            styles={style}
          />
        </Col>
      </Row>
    </>
  );
};

export default WaterSystemSearch;
